import Column from '@components/Column';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { useFlow } from '@stackflow/react';
import { Fragment } from 'react';

import PlusIcon from './PlusIcon';

function NewGiftFab() {
    const { push } = useFlow();
    const handleRegister = () => {
        push('NewGiftBottomSheet', {});
    };
    const { useCouponButton, couponButtonText } = useAppCustom().membership;
    if (useCouponButton) {
        return (
            <Container onClick={handleRegister}
                align='center'
                spacing={10}>
                <Floating>
                    <PlusIcon/>
                </Floating>
                <CouponButton>
                    {couponButtonText}
                </CouponButton>
            </Container>
        );
    }
    return (<Fragment/>);
}

const Container = styled(Column)`
    bottom: 48px;
    position: fixed;
    right: 24px;
`;

const Floating = styled.div`
    align-items: center;
    background-color: var(--color-primary);
    border-radius: 40px;
    display: flex;
    filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.20));
    height: 80px;
    justify-content: center;
    width: 80px;
`;

const CouponButton = styled.button`
    background-color: var(--color-gray2);
    border-radius: 18px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.20);
    color: var(--color-gray7);
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    padding: 8px 10px;
`;

export default NewGiftFab;
